import React, { memo, useCallback, useMemo } from 'react';
import { Button, RadioButton } from '@appsumo/dorado-react';

import { Survey } from '~/types/survey/types';
import { SurveyContainer } from '~/components/survey/SurveyContainer';

interface PurchaseSurveyComponentProps {
  survey: Survey;
}

export default memo(function RadioList({
  survey,
}: Readonly<PurchaseSurveyComponentProps>) {
  // TODO
  // const { submit, dismiss } = useContext(SurveyContext);

  const question = useMemo(() => {
    return survey.questions?.[0];
  }, [survey.questions]);

  const onChange = useCallback((value: number) => {
    console.log('onChange', value);
  }, []);

  const onSubmit = useCallback(() => {
    // TODO
  }, []);

  const onDismiss = useCallback(() => {
    // TODO
  }, []);

  if (!survey.questions) {
    return null;
  }

  return (
    <SurveyContainer
      title={question.text}
      isSubmitted={false}
      className="right-0 top-1/2 -translate-y-1/2"
      onClose={onDismiss}
    >
      <div key={question.id} className="flex flex-col justify-start gap-y-2">
        {question.choices.map((choice) => (
          <RadioButton
            key={choice.id}
            label={choice.label}
            name="choice"
            // @ts-ignore
            onChange={() => onChange(choice.label)}
          />
        ))}
      </div>
      <Button
        // @ts-ignore
        onClick={onSubmit}
      >
        Submit
      </Button>
    </SurveyContainer>
  );
});
